import{__decorate as t,e,n as s}from"../../../d4cffba7.js";import{n as i,r as o,y as a,x as r}from"../../../493beda6.js";import{defaultStyles as p}from"../../../styles.js";import{exportParts as l}from"../../../directives/ExportParts.js";import{Popover as d}from"../../Popover.js";import"../../Tooltip.js";import"../../../f75f919c.js";import"../../../af1106fb.js";import"../../../icons/monochrome/help.js";var n;let c=n=class extends i{constructor(){super(...arguments),this.header="",this.helpText=null}static get styles(){return[p,o`
        :host {
          display: block;
        }
        div.layout {
          display: grid;
          grid-template-columns: auto;
          grid-template-rows: auto;
          gap: 0.5rem;
        }
        div.layout.table {
          grid-template-columns: 120px auto;
        }
        div.heading {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
      `]}render(){return a`
      <div part=${n.cssParts.layout} class="layout">
        <div part=${n.cssParts.heading} class="heading">
          <div part=${n.cssParts.headingText}>${this.header}</div>
          <slot name="help">
            ${this.helpText?a`<cai-tooltip exportparts=${l(d.cssParts)}>
                  <div slot="content">${this.helpText}</div>
                </cai-tooltip>`:r}
          </slot>
        </div>
        <slot></slot>
      </div>
    `}};c.cssParts=Object.assign(Object.assign({},d.cssParts),{layout:"section-layout",heading:"section-heading",headingText:"section-heading-text"}),t([e({type:String})],c.prototype,"header",void 0),t([e({type:String})],c.prototype,"helpText",void 0),c=n=t([s("cai-panel-section")],c);export{c as PanelSection};
